export { default } from "./ImageBox";
